import referenceDuckCreator from './creators/referenceDuckCreator/referenceDuckCreator';

export default referenceDuckCreator();
